import styled from 'styled-components';

export const CTAButtonMiddleBlock = styled('div')`
  display: flex;
  flex: auto;
  justify-content: center;
  align-items: center;
`;
